import {
  Alert,
  AlertIcon,
  Box,
  Button,
  Flex,
  Input,
  Switch,
  Text,
  useTheme,
} from "@chakra-ui/react";
import React from "react";
import { Theme } from "../../theme";
import { useNavigate } from "react-router-dom";
import getAxios from "../../hooks/useAxios";
import Cookies from "js-cookie";
import { FaArrowRight } from "react-icons/fa";

const CreatePeakHour = () => {
  const theme = useTheme<Theme>();
  const navigate = useNavigate();

  const axios = getAxios();
  const access_token = Cookies.get("x-admin-auth");

  const [startTime, setStartTime] = React.useState("");
  const [endTime, setEndTime] = React.useState("");
  const [status, setStatus] = React.useState(false);
  const [createStatus, setCreateStatus] = React.useState("");

  const handleCreatePeakHour = async (e: React.BaseSyntheticEvent) => {
    e.preventDefault();
    const data = {
      start_time: startTime,
      end_time: endTime,
      status: status ? "active" : "inactive",
    };

    try {
      const res = await axios.post(`/peak-hours`, data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      setCreateStatus("created");
      console.log("submit", res);
      setTimeout(() => {
        navigate("/incentives");
      }, 2000);
    } catch (error) {
      console.log(error);
      setCreateStatus("error");
    }
  };

  return (
    <Box style={{ padding: "2rem" }}>
      <Text
        sx={{
          fontSize: theme.fontSizes.subHeading2,
          marginBottom: theme.space["3xl"],
        }}
      >
        Create Peak Hour
      </Text>

      <Box
        style={{
          width: "50%",
          backgroundColor: "#FFFFFF",
          padding: "2rem",
          borderRadius: "8px",
        }}
      >
        <form onSubmit={handleCreatePeakHour}>
          <Flex flexDirection={"column"}>
            <label style={{ display: "block", marginTop: theme.space.xl }}>
              Peak hour start time:
            </label>
            <Input
              type="time"
              value={startTime}
              onChange={(e) => setStartTime(e.target.value)}
              name="startTime"
              placeholder="startTime"
              variant={"outline"}
            />

            <label style={{ display: "block", marginTop: theme.space.xl }}>
              Peak hour end time:
            </label>
            <Input
              type="time"
              value={endTime}
              onChange={(e) => setEndTime(e.target.value)}
              name="endTime"
              placeholder="endTime"
              variant={"outline"}
            />

            <Flex
              sx={{
                gap: "1rem",
                alignItems: "center",
                marginTop: theme.space.xl,
              }}
            >
              <Text
                sx={{
                  fontSize: theme.fontSizes.caption,
                  marginTop: theme.space.sm,
                }}
                color={theme.colors.secondary.light}
              >
                Active this peak hour time now?
              </Text>
              <Switch
                isChecked={status}
                colorScheme="red"
                size="sm"
                style={{ marginTop: "0.5rem" }}
                onChange={() => {
                  setStatus(!status);
                }}
              />
            </Flex>

            <Box sx={{ marginTop: theme.space.xxl }}>
              <Button
                type="submit"
                width="100%"
                height="3rem"
                rightIcon={<FaArrowRight />}
                // isLoading={isLoginLoading ? true : false}
                style={{
                  background: theme.colors.primary.main,
                  color: theme.colors.bg.main,
                }}
              >
                <Text sx={{ fontSize: theme.fontSizes.body }}>Create</Text>
              </Button>
            </Box>

            <Box sx={{ minHeight: "3.25rem" }}>
              {createStatus === "created" && (
                <Alert status="success">
                  <AlertIcon />
                  Peak hour created successfully.
                </Alert>
              )}
              {createStatus === "error" && (
                <Alert status="error" borderRadius={"4px"}>
                  <AlertIcon />
                  Opps! Something went wrong.
                </Alert>
              )}
            </Box>
          </Flex>
        </form>
      </Box>
    </Box>
  );
};

export default CreatePeakHour;
